import { ClipLoader } from "react-spinners";
import { ButtonTheme } from "./ButtonTheme";

export interface ButtonProps {
  text: string;
  enabled: boolean;
  loading: boolean;
  theme: ButtonTheme;
  onClick: () => void;
}

export default function Button(props: ButtonProps) {
  return (
    <button
      onClick={(event) => {
        event.stopPropagation();
        if (props.enabled) props.onClick();
      }}
      className={
        "transition-all flex flex-row items-center drop-shadow-lg font-archb text-base rounded-lg hover:scale-105 duration-250 px-6 py-2 " +
        (props.enabled
          ? "bg-gradient-to-b hover:bg-gradient-to-t " +
            props.theme +
            " text-cinder"
          : "bg-transparent border-solid border-2 border-gray text-gray")
      }
    >
      {props.text}
      <ClipLoader
        className="ml-2.5"
        size="14px"
        loading={props.loading}
        aria-label="Loading Spinner"
        data-testid="loader"
        color={props.enabled ? "#0e0d13" : "#898989"}
      />
    </button>
  );
}
